// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/rating.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.bgg',
	post: false,
	require: function(config, filter) { return sorted('rating.bgg', filter) > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_rating_avg', '>', 0)
		query.order('g.game_rating_avg', sortReverse('rating.bgg', filter), sortPriority('rating.bgg', filter))
	}
}
